// removed by extract-text-webpack-plugin
module.exports = {"title":"title___19knV","description":"description___3_rVD","spot":"spot___2McNG","container":"container___ZFpJE","addSpot":"addSpot___1GJ4z","addSpotTxt":"addSpotTxt___1NVOM","message":"message___1w78c","loading":"loading___2PRvh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Spotpoint/Spotpoint.module.css
// module id = 398
// module chunks = 0